module.exports = __webpack_public_path__ + "static/media/font-case.1560fc27.svg";